<template>
  <div>
    <h1 class="h3 mb-2 text-gray-800">
      {{ $t("Gestão de Logradouro (Rua, Av, Quadra etc.)") }}
    </h1>
    <b-alert variant="info" :show="showAlert">
      Para um bom funcionamento do sistema precisamos que as localidades sejam
      importadas antes da importação dos logradouros
      <b-button
        @click="importarLocalidades()"
        class="alert-link"
        :title="$t('Importar Localidades')"
        v-b-tooltip.hover
        variant="primary"
        type="button"
        v-if="$store.state.user.role_details.name == 'Admin'"
      >
        <i class="fas fa-cloud-upload-alt" />
        {{ $t("Importar Localidades") }}
      </b-button>
    </b-alert>
    <b-card class="shadow">
      <div class="row">
        <div class="col-12">
          <div class="row">
            <div
              class="col-12 d-flex align-items-center justify-content-between mb-4"
            >
              <div>
                <router-link
                  class="btn btn-primary"
                  to="/dashboard/enderecos/logradouros/add"
                >
                  <i class="fas fa-plus-square" />
                  {{ $t("Cadastrar") }}
                </router-link>

                <b-button
                  :title="$t('Importar Logradouros')"
                  @click="importarLogradouros()"
                  class="btn-importar"
                  type="button"
                  v-b-tooltip.hover
                  variant="primary"
                  :disabled="DisabledBottonLogradouros"
                  v-if="$store.state.user.role_details.name == 'Admin'"
                >
                  <i class="fas fa-cloud-upload-alt" />
                  {{ $t("Importar Logradouros") }}
                </b-button>
              </div>
              <div v-if="filtroLocalidade" style="line-height: 24px">
                {{ filtroLocalidade }}

                <b-button
                  :title="$t('Cancelar filtro')"
                  @click="cancelarfiltrarPorLocalidade()"
                  v-b-tooltip.hover
                  type="button"
                  class="btn-xs mt-2"
                  variant="default"
                >
                  Cancelar
                </b-button>
              </div>
              <div>
                <div class="input-group mb-3">
                  <b-input
                    :placeholder="$t('Type to search')"
                    class="form-control search-input"
                    type="text"
                    v-model="search"
                    v-on:change="getLogradouros"
                    aria-describedby="input-search"
                  />
                  <div class="input-group-append" role="button">
                    <span class="input-group-text" id="input-search"
                      ><i class="fas fa-search search-icon"
                    /></span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12">
              <loading-animation
                :active.sync="loadingRead"
                :is-full-page="false"
                :opacity="1"
                color="#5895FF"
              />
              <b-table
                :fields="[
                  {
                    key: 'id',
                    label: $t('Código'),
                  },
                  {
                    key: 'tipo_logradouro',
                    label: $t('Tipo'),
                  },
                  {
                    key: 'titulo_logradouro',
                    label: $t('Título'),
                  },
                  {
                    key: 'nome_logradouro',
                    label: $t('Nome'),
                  },
                  {
                    key: 'localidade',
                    label: $t('Bairro'),
                  },
                  {
                    key: 'cep_logradouro',
                    label: $t('Cep'),
                  },
                  {
                    key: 'atualizado',
                    label: $t('Atualizado em'),
                  },
                  {
                    class: 'text-right',
                    key: 'actions',
                    label: '',
                  },
                ]"
                :items="logradourosList"
                :responsive="true"
                fixed
                striped
                hover
                show-empty
                small
                outlined
                stacked="md"
                table-class="mb-3"
              >
                <template v-slot:cell(id)="data">
                  {{ data.value }}
                </template>
                <template v-slot:cell(tipo_logradouro)="data">
                  {{ data.value }}
                </template>
                <template v-slot:cell(titulo_logradouro)="data">
                  {{ data.value }}
                </template>
                <template v-slot:cell(nome_logradouro)="data">
                  {{ data.value }}
                </template>
                <template v-slot:cell(localidade)="data">
                  <b-link
                    @click="
                      filtrarPorLocalidade(data.value.id, data.value.value)
                    "
                  >
                    {{ data.value.value }}
                  </b-link>
                </template>
                <template v-slot:cell(cep_logradouro)="data">
                  {{ data.value }}
                </template>
                <template v-slot:cell(atualizado)="data">
                  {{ data.value }}
                </template>
                <template v-slot:cell()="data">
                  <b-button
                    :title="$t('Edit Logradouro')"
                    :to="
                      '/dashboard/enderecos/logradouros/edit/' + data.item.id
                    "
                    class="px-2 mb-0"
                    size="xs"
                    type="button"
                    v-b-tooltip.hover
                    variant="success"
                  >
                    <i class="mdi mdi-square-edit-outline" />
                  </b-button>
                </template>
                <template v-slot:empty="scope">
                  <div class="text-center my-5">
                    <img
                      :alt="$t('No results')"
                      class="mb-5"
                      src="/img/icons/robot.svg"
                      style="max-height: 165px"
                    />
                    <h3 class="bold">{{ $t("No records found") }}</h3>
                  </div>
                </template>
                <template v-slot:emptyfiltered="scope">
                  <div class="text-center my-5">
                    <img
                      :alt="$t('No results')"
                      class="mb-5"
                      src="/img/icons/robot.svg"
                      style="max-height: 165px"
                    />
                    <h3>{{ $t("No records match the entered search") }}</h3>
                  </div>
                </template>
              </b-table>

              <div class="row align-items-center">
                <div class="col-lg-6 col-md-12">
                  <div class="form-group d-inline-flex mb-0">
                    <select
                      class="form-control"
                      style="width: 70px"
                      v-model="perPage"
                      v-on:change="getLogradouros"
                    >
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                    </select>
                  </div>
                  <div class="d-inline-flex ml-2">
                    <b-pagination
                      :per-page="perPage"
                      :total-rows="pagination.total"
                      @change="changePage"
                      v-model="page"
                    />
                  </div>
                </div>
                <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
                  <div class="float-lg-right">
                    {{ $t("Showing page") }} {{ pagination.currentPage }}
                    {{ $t("of") }} {{ pagination.totalPages }}
                    {{ $t("pages in") }} {{ pagination.total }}
                    {{ $t("records") }}
                  </div>
                </div>
              </div>
            </div>
            <router-view />
          </div>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "Read",
  metaInfo() {
    return {
      title: this.$i18n.t("Gestão de Logradouros"),
    };
  },
  data() {
    return {
      DisabledBottonLogradouros: false,
      page: 1,
      search: "",
      perPage: 10,
      loadingRead: true,
      pagination: {
        currentPage: 0,
        perPage: 0,
        total: 0,
        totalPages: 0,
      },
      logradourosList: [],
      showAlert: false,
      localidade: null,
      filtroLocalidade: null,
    };
  },
  mounted() {
    this.getLogradouros();
    this.getLocalidades();
  },
  methods: {
    // Change the page
    changePage(page) {
      if (
        page > 0 &&
        page <= this.pagination.totalPages &&
        page !== this.page
      ) {
        this.page = page;
        this.getLogradouros();
      }
    },
    filtrarPorLocalidade(id, nome) {
      this.localidade = id;
      this.filtroLocalidade = "Filtrando pela localidade: " + nome;
      this.getLogradouros();
    },
    cancelarfiltrarPorLocalidade() {
      this.localidade = null;
      this.filtroLocalidade = null;
      this.getLogradouros();
    },
    // Get roles list
    getLogradouros() {
      this.loadingRead = true;
      axios
        .get("api/dashboard/enderecos/logradouros", {
          params: {
            page: this.page,
            search: this.search,
            perPage: this.perPage,
            localidade: this.localidade,
          },
        })
        .then((response) => {
          this.logradourosList = response.data.data;
          this.pagination = response.data.pagination;
          if (this.pagination.totalPages < this.pagination.currentPage) {
            this.page = this.pagination.totalPages;
            this.getLogradouros();
          } else {
            this.loadingRead = false;
          }
        })
        .catch(() => {
          this.loadingRead = false;
        });
    },
    importarLogradouros() {
      let ladda = Ladda.create(document.querySelector(".btn-importar"));
      ladda.start();

      axios
        .post("api/dashboard/enderecos/importar/logradouros")
        .then((response) => {
          ladda.stop();
          this.$snack.show({
            button: false,
            text: response.data.data.message,
          });

          ladda.stop();
          this.getLogradouros();
        });
    },
    importarLocalidades() {
      let ladda = Ladda.create(document.querySelector(".btn-importar"));
      ladda.start();
      axios
        .post("api/dashboard/enderecos/importar/localidades")
        .then((response) => {
          ladda.stop();
          this.$snack.show({
            button: false,
            text: response.data.data.message,
          });

          ladda.stop();

          this.$router.push("/dashboard/enderecos/logradouros");
          this.$parent.getLocalidades();
        })
        .catch(() => {
          this.showAlert = false;
          this.DisabledBottonLogradouros = false;
        });
    },
    getLocalidades() {
      this.DisabledBottonLogradouros = false;
      axios
        .get("api/dashboard/enderecos/localidades")
        .then((response) => {
          this.totalLocalidades = response.data.data.length;
          if (response.data.data.length == 0) {
            this.showAlert = true;
            this.DisabledBottonLogradouros = true;
          } else {
            this.showAlert = false;
            this.DisabledBottonLogradouros = false;
          }
        })
        .catch(() => {
          this.loadingRead = false;
        });
    },
  },
};
</script>
